/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<a7911f383b725ae7fc86d319995a73a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type subsectionViewRendererFragment$data = {
  readonly __id: string;
  readonly config: {
    readonly span: number | null | undefined;
  } | null | undefined;
  readonly elements: ReadonlyArray<{
    readonly __id: string;
    readonly " $fragmentSpreads": FragmentRefs<"elementErrorBoundaryFragment" | "elementViewRendererFragment">;
  } | null | undefined> | null | undefined;
  readonly visualConfig?: {
    readonly " $fragmentSpreads": FragmentRefs<"alignmentSettingsContextFragment" | "alignmentSettingsContextHookFragment">;
  } | null | undefined;
  readonly " $fragmentType": "subsectionViewRendererFragment";
};
export type subsectionViewRendererFragment$key = {
  readonly " $data"?: subsectionViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"subsectionViewRendererFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "subsectionViewRendererFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutSubsectionConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "span",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "elements",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "elementViewRendererFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "elementErrorBoundaryFragment"
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpLayoutVisualConfig",
          "kind": "LinkedField",
          "name": "visualConfig",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "alignmentSettingsContextFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "alignmentSettingsContextHookFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "HelpLayoutVisualEntity",
      "abstractKey": "__isHelpLayoutVisualEntity"
    },
    (v0/*: any*/)
  ],
  "type": "HelpLayoutSubsection",
  "abstractKey": null
};
})();

(node as any).hash = "37072e0ebb33eef1bc37c8cb0189d498";

export default node;
